<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="头像" prop="avatar">
            <a-upload
              :customRequest="fileUploadRequest"
              list-type="picture-card"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
              @change="handleChange">
              <img v-if="form.avatar" :src="form.avatar" alt="图片" style="height:104px;max-width:300px"/>
              <div v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="姓名" prop="nickname">
            <a-input v-model="form.nickname" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="身份证号" prop="idCard">
            <a-input v-model="form.idCard" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="出生年月" prop="birthday">
            <a-date-picker
              style="width: 40%"
              v-model="form.birthday"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="微信号" prop="wxCode">
            <a-input v-model="form.wxCode" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="手机号" prop="mobile">
            <a-input v-model="form.mobile" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="地区" prop="district">
            <a-input v-model="district" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="学历" prop="education">
            <a-select v-model="form.education" placeholder="请选择">
              <a-select-option :value="1">高中</a-select-option>
              <a-select-option :value="2">大专</a-select-option>
              <a-select-option :value="3">本科</a-select-option>
              <a-select-option :value="4">研究生</a-select-option>
              <a-select-option :value="5">博士生</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="性别" prop="sex">
            <a-select v-model="form.sex" placeholder="请选择">
              <a-select-option :value="0">保密</a-select-option>
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="意向岗位" prop="workId">
            <a-select v-model="form.workId" placeholder="请选择">
              <a-select-option v-for="(work,index) in workTypeList" :key="index" :value="work.id">
                {{ work.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="籍贯" prop="nativePlace">
            <a-input v-model="form.nativePlace" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="民族" prop="nation">
            <a-input v-model="form.nation" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="身高（CM）" prop="height">
            <a-input-number :step="0.01" v-model="form.height" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="体重（kg）" prop="weight">
            <a-input-number :step="0.01" v-model="form.weight" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="是否有纹身" prop="hasTattoo">
            <a-select v-model="form.hasTattoo" placeholder="请选择">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="是否残疾" prop="isDisability">
            <a-select v-model="form.isDisability" placeholder="请选择">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="残疾详情" prop="disabilityDetail">
            <a-textarea :row="3" v-model="form.disabilityDetail" placeholder="请输入" :disabled="form.isDisability == 0" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="渠道来源" prop="sourceChannel">
            <a-select v-model="form.sourceChannel" placeholder="请选择">
              <a-select-option v-for="(channel,index) in sourceChannelList" :key="index" :value="channel.id">
                {{ channel.content }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="招聘专员" prop="topUserId">
            <a-select v-model="form.topUserId" placeholder="请选择" :disabled="disabledUser1">
              <a-select-option v-for="(topUser,index) in topUserList" :key="index" :value="topUser.id">
                {{ topUser.nickname }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="推荐官" prop="referralsUserId">
            <a-select v-model="form.referralsUserId" placeholder="请选择" :disabled="disabledUser2">
              <a-select-option v-for="(referralsUser,index) in referralsUserList" :key="index" :value="referralsUser.id">
                {{ referralsUser.nickname }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="推荐官专员" prop="topReferralsUserId">
            <a-select v-model="form.topReferralsUserId" placeholder="请选择" :disabled="disabledUser3">
              <a-select-option v-for="(topReferralsUser,index) in topReferralsUserList" :key="index" :value="topReferralsUser.id">
                {{ topReferralsUser.nickname }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="报备公司" prop="companyId">
            <a-select v-model="form.companyId" placeholder="请选择" @change="queryPostList">
              <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">
                {{ company.companyName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="报备岗位" prop="postId">
            <a-select v-model="form.postId" placeholder="请选择">
              <a-select-option v-for="(post,index) in postList" :key="index" :value="post.id">
                {{ post.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="面试时间" prop="interviewTime">
            <a-date-picker
              style="width: 100%"
              v-model="form.interviewTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="推荐官是否参与" prop="isReferralsTake">
            <a-radio-group v-model="form.isReferralsTake">
              <a-radio :value="0">否</a-radio>
              <a-radio :value="1">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="标签(专员)" prop="oneTagIds">
            <a-select v-model="oneTagIds" mode="multiple" placeholder="请选择">
              <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
                {{ tag.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="标签(推荐官)" prop="twoTagIds">
            <a-select v-model="twoTagIds" mode="multiple" placeholder="请选择">
              <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
                {{ tag.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="求职意向" prop="jobIntention">
            <a-textarea :row="3" v-model="form.jobIntention" placeholder="请输入"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="上传简历" prop="resumeUrl">
            <a-spin tip="上传中..." :spinning="uploading">
              <a-upload-dragger
                name="file"
                accept=".pdf"
                :file-list="fileList"
                :multiple="false"
                :remove="handleRemove"
                :before-upload="beforeUploadFile"
              >
                <p class="ant-upload-hint">
                  支持pdf格式
                </p>
              </a-upload-dragger>
            </a-spin>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addUser, querySourceChannelList, queryOperator, queryUserByType } from '@/api/biz/user'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import { listTag } from '@/api/user/tag'
import { listWork } from '@/api/user/work'
import { listCompany } from '@/api/user/company'
import { listCompanyPost } from '@/api/user/companyPost'

export default {
  name: 'AddUserForm',
  props: {
    sexOptions: {
      type: Array
    },
    isNoticeOptions: {
      type: Array
    },
    statusOptions: {
      type: Array
    }
  },
  components: {
  },
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploading: false,
      fileList: [],
      formTitle: '',
      activeKey: '1',
      tagList: [],
      oneTagIds: [],
      twoTagIds: [],
      workTypeList: [],
      companyList: [],
      postList: [],
      sourceChannelList: [],
      topUserList: [],
      referralsUserList: [],
      topReferralsUserList: [],
      disabledUser1: false,
      disabledUser2: false,
      disabledUser3: false,
      district: null,
      // 表单参数
      form: {
        avatar: null,
        nickname: null,
        idCard: null,
        birthday: null,
        wxCode: null,
        mobile: null,
        education: null,
        sex: null,
        workId: null,
        nativePlace: null,
        nation: null,
        height: null,
        weight: null,
        hasTattoo: null,
        isDisability: null,
        disabilityDetail: null,
        jobIntention: null,
        sourceChannel: null,
        topUserId: null,
        referralsUserId: null,
        topReferralsUserId: null,
        companyId: null,
        postId: null,
        interviewTime: null,
        isReferralsTake: 0,
        resumeUrl: null,
        oneTagIds: null,
        twoTagIds: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        sourceChannel: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        topUserId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    listUserByType(type) {
      const param = { type: type }
      queryUserByType(param).then(response => {
        if (type === 1) {
          this.topUserList = response.data
        }
        if (type === 2) {
          this.referralsUserList = response.data
        }
        if (type === 3) {
          this.topReferralsUserList = response.data
        }
      })
    },
    querySourceChannelList() {
      const param = {}
      querySourceChannelList(param).then(response => {
        this.sourceChannelList = response.data
      })
    },
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    queryPostList() {
      const param = { companyId: this.form.companyId }
      listCompanyPost(param).then(response => {
        this.postList = response.data
      })
    },
    queryWorkList() {
      const param = {}
      listWork(param).then(response => {
        this.workTypeList = response.data
      })
    },
    queryTagList() {
      const param = { type: 3 }
      listTag(param).then(response => {
        this.tagList = response.data
      })
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    beforeUploadFile(fileInfo) {
      this.fileList = [fileInfo]
      console.log(this.fileList)
      this.form.resumeUrl = this.fileList[0]
      return false
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.avatar = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.tagList = []
      this.oneTagIds = []
      this.twoTagIds = []
      this.workTypeList = []
      this.companyList = []
      this.postList = []
      this.fileList = []
      this.topUserList = []
      this.referralsUserList = []
      this.topReferralsUserList = []
      this.disabledUser1 = false
      this.disabledUser2 = false
      this.disabledUser3 = false
      this.form = {
        avatar: null,
        nickname: null,
        idCard: null,
        birthday: null,
        wxCode: null,
        mobile: null,
        education: null,
        sex: null,
        workId: null,
        nativePlace: null,
        nation: null,
        height: null,
        weight: null,
        hasTattoo: null,
        isDisability: null,
        disabilityDetail: null,
        jobIntention: null,
        sourceChannel: null,
        topUserId: null,
        referralsUserId: null,
        topReferralsUserId: null,
        companyId: null,
        postId: null,
        interviewTime: null,
        isReferralsTake: 0,
        resumeUrl: null,
        oneTagIds: null,
        twoTagIds: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.queryTagList()
      this.queryWorkList()
      this.queryCompanyList()
      this.querySourceChannelList()
      this.listUserByType(1)
      this.listUserByType(2)
      this.listUserByType(3)
      queryOperator().then(response => {
        this.form.modifierName = response.data.nickName
        const user = response.data.user
        if (user.clientType === 1 && user.userType === 2) {
          this.form.topUserId = user.id
          this.disabledUser1 = true
        }
        if (user.clientType === 2 && user.userType === 1) {
          this.form.referralsUserId = user.id
          this.disabledUser2 = true
        }
        if (user.clientType === 2 && user.userType === 2) {
          this.form.topReferralsUserId = user.id
          this.disabledUser3 = true
        }
      })
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.oneTagIds = this.oneTagIds.join(',')
      this.form.twoTagIds = this.twoTagIds.join(',')
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          addUser(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
